<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_i">Death in Harley Street</a></h1><a id="page_i">
<p class="subtitle">A Dr. Priestley Detective Story</p>
<p class="titlea">John Rhode</p>
</a><p class="centerimg"><a id="page_i"><img alt="image" class="Title Page" src="images/logo3.jpg"/></a><a id="page_ii"></a></p><a id="page_ii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Titlepage.vue?3cece663